import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../../shared/SectionCard'
import StarRating from '../../shared/StarRating'
import './style.css'
import { Validations } from '@/utils/validations'
import { Block } from '@/components/crRender'
import doctorPlaceholder  from "@assets/placeholders/doctor-placeholder.png"
import { Link } from 'react-router-dom'

const TopRatedDoctors = ({ topDoctors }) => {
    const { t } = useTranslation()

    return (
        <Block isRender={!Validations.isArrayEmpty(topDoctors)} className="top-rated-doctors-section">

            <SectionCard icon="mdi:doctor" titleKey="top-rated-doctors">
                <div className="doctors-list">
                    {topDoctors?.mapWithKey((doctor) => (
                        <div key={doctor.key} className="doctor-card">
                            <img
                                src={window.API_URL + doctor?.files?.[0]?.data?.[0]?.name}
                                alt={doctor.name}
                                className="doctor-avatar"
                                onError={(e) => e.target.src =doctorPlaceholder}
                            />
                            <div className="doctor-info">
                                <div className="doctor-name">{doctor.name}</div>
                                <StarRating rating={doctor.rating} />
                                <div className="doctor-specialty">{doctor.specialtyName}</div>
                                <div className="doctor-sub-specialty">{doctor.majorSpecialtyName}</div>
                            </div>
                            <Link to={`/panel/provider/doctors/details/${doctor?.id}`} className="view-profile-link" >
                                {t("view-profile")}
                            </Link>
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default TopRatedDoctors

